import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, makeStyles, Text, Title2 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { IFAQItem } from "../../models/page/pageComponents/IPageFAQ";
import { dolphinTokens } from "../../utils/Theme";

const useStyles = makeStyles({
    section: {
        width: "100%",
        maxWidth: "800px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
    },
    title: {
        marginBottom: "10px",
        textAlign: "center",
    },
    item: {
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        marginBottom: "8px"
    },
    question: {
        color: `${dolphinTokens.colorLightBlue} !important`
    },
    answer: {
        display: "block",
        lineHeight: "1.7",
        padding: "0 16px 16px"
    }
});

export default function BlogFAQ(props: { items: IFAQItem[] }) {
    const { t } = useTranslation("blog");
    const styles = useStyles();
    const completedItems = props.items.filter((item) => item.question.trim() && item.answer.trim());

    if (!completedItems.length) {
        return null;
    }

    return (
        <section className={styles.section}>
            <Title2 as="h2" className={styles.title}>{t("faq.title")}</Title2>
            <Accordion collapsible>
                {completedItems.map((item, index) => (
                    <AccordionItem key={index} value={`blog-faq-${index}`} className={styles.item}>
                        <AccordionHeader className={styles.question}>{item.question}</AccordionHeader>
                        <AccordionPanel>
                            <Text className={styles.answer}>{item.answer}</Text>
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </section>
    );
}
